export default __webpack_public_path__ + "static/media/main-bg1.97a94e6c.jpg";